module.exports = __webpack_public_path__ + "static/media/item-5.68ad10f1.jpeg";